import React from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../../context/DataContext';
import { getIconWithFallback } from '../../utils/iconMap';
import '../../styles/components/CategoryCards.css';

const CategoryCards = () => {
  const { getFeaturedCategories } = useData();

  // Get featured categories from the single source of truth
  const categories = getFeaturedCategories();

  return (
    <section className="category-section">
      <div className="container">
        <div className="category-grid">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/products?category=${encodeURIComponent(category.id)}`}
              className="category-card"
            >
              <h3 className="category-name">{category.name}</h3>
              <div className="category-icon" style={{ color: category.color }}>
                {getIconWithFallback(category.icon, 'faLeaf')}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryCards;

